<!-- 此组件用于product页面的个人字幕服务展示 -->
<template>
    <div class="personal" id="personal">
        <div id="voiApp">
            <p class="bigText">多场景个人字幕服务 , 你想要的都满足</p>
            <p class="smallText">音书APP ，让字幕无处不在</p><br>
            <img src="../assets/product/voibook-app.png" style="width:100%;">
        </div>
        <div id="offline">
            <div class="bar">
                <img src="../assets/product/bar.png">
                <span class="bigText">线下字幕服务</span>
            </div>
            <div class="content">
                <img src="../assets/product/distance.png">
                <div class="text">
                    <div class="bar">
                        <img src="../assets/product/麦克拷贝2.png">
                        <span class="bigText">远距离翻译字幕</span>
                    </div>
                    <p class="smallText">提供开会、培训、上课、聚会、购物等多场景的字幕服务</p>
                    <div class="blueText" @click="to('/video/1')">
                        <span>视频教程</span>
                        <img src="../assets/product/arrow_2x.png">
                    </div>
                </div>
            </div>
            <div class="content">
                <div class="text">
                    <div class="bar">
                        <img src="../assets/product/手写字幕.png">
                        <span class="bigText">手写字幕</span>
                    </div>
                    <p class="smallText">交流不便时，可以通过手写字幕来表达自己的意思，更有滑条和缩放两种模式可以选择</p>
                    <div class="blueText" @click="to('/video/1')">
                        <span>视频教程</span>
                        <img src="../assets/product/arrow_2x.png">
                    </div>
                </div>
                <img src="../assets/product/handwrite.png">
            </div>
        </div>
        <div id="online">
            <div class="bar">
                <img src="../assets/product/bar.png">
                <span class="bigText">线上字幕服务</span>
            </div>
            <div class="content">
                <img src="../assets/product/rtc-caption.png">
                <div class="text">
                    <div class="bar">
                        <img src="../assets/product/video-chat.png">
                        <span class="bigText">视频聊天字幕</span>
                    </div>
                    <p class="smallText">一边与家人朋友聊天，一边实时翻译双方对话内容</p>
                    <div class="blueText" @click="to('/video/3')">
                        <span>视频教程</span>
                        <img src="../assets/product/arrow_2x.png">
                    </div>
                </div>
            </div>
            <div class="content">
                <div class="text">
                    <div class="bar">
                        <img src="../assets/product/phone.png">
                        <span class="bigText">电话沟通字幕</span>
                    </div>
                    <p class="smallText">随时随地打电话，“看见”对方的声音</p>
                    <div class="blueText" @click="to('/video/4')">
                        <span>视频教程</span>
                        <img src="../assets/product/arrow_2x.png">
                    </div>
                </div>
                <img src="../assets/product/call_2x.png">
            </div>
            <div class="content">
                <img src="../assets/product/suspention.png">
                <div class="text">
                    <div class="bar">
                        <img src="../assets/product/icon.png">
                        <span class="bigText">悬浮翻译字幕</span>
                    </div>
                    <p class="smallText">看直播、刷抖音、了解新闻时事</p>
                    <div class="blueText" @click="to('/video/6')">
                        <span>视频教程</span>
                        <img src="../assets/product/arrow_2x.png">
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script scoped>
export default {
    name: 'personalSubtitleService',
    methods: {
        to (path) {
            this.$router.push(path)
        }
    }
}
</script>

<style scoped>
.personal{
    text-align:center;
}
#voiApp, #offline, #online{
    width: 75vw;
    margin-top:15%;
}
.bigText{
    font-size:3em;
    font-weight: 450;
}
.smallText{
    font-size:1.5em;
    font-weight: 300;
    letter-spacing: 1px;
}
.bar{
    display: flex;
    display: -webkit-flex;
    align-items: center;
}
.bar img{
    margin-right:3%;
}
.content{
    width:90%;
    display: flex;
    display: -webkit-flex;
    align-items: center;
    justify-content: space-between;
    margin:10% 0;
}
.content>img{
    width:50%;
}
.text{
    text-align: left;
    width:40%;
}
.text .bar img{
    width:15%;
    margin-right: 6%;
}
.text .bigText{
    font-size: 2em;
}
.blueText{
    display:flex;
    display: -webkit-flex;
    align-items: center;
    width: auto;
    cursor: pointer;
    max-width: 120px;
}
.blueText span{
    color: rgb(0, 174, 255);
    font-size: 1.5em;
    font-weight: 200;
}
.blueText img{
    margin-left:8px;
    width:8%;
}
@media screen and (max-width:1000px){
    .bigText{
        font-size: 2em;
    }
    .text .bigText{
        font-size: 1.5em;
    }
    .smallText, .blueText span{
        font-size: 1.3em;
    }
}
@media screen and (max-width: 700px){
    .text .bar img{
        width: 1.5em;
    }
    .text .bigText{
        font-size: 1.2em
    }
    .text .smallText{
        font-size:0.8em;
    }
    .blueText span{
        font-size: 1em;
    }
    .blueText img{
        width:1em;
    }
}
@media screen and (max-width:550px){
    .text .bigText{
        font-size: 1em;
    }
}
@media screen and (max-width: 450px){
    .text .smallText{
        font-size: 0.6em;
        line-height: 1.0;
    }
    .blueText span{
        font-size: 0.8em;
    }
    .blueText img{
        width: 0.8em;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/personalSubTitleService.vue